import type { Appointment } from "@rmh/defs";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

interface FilterAvailableTimestampParams {
  availableTimes: string[];
  date: string;
  start: Dayjs;
  end: Dayjs;
}

export const filterAvailableTimestamp = ({
  availableTimes,
  date,
  start,
  end,
}: FilterAvailableTimestampParams) => {
  return availableTimes.filter((timestamp) => {
    const day = `${date}T${timestamp}`;

    return dayjs(day).isBetween(start, end, null, "[]");
  });
};

interface FilterAvailableAppointmentsParams {
  appointments: Appointment[];
  start: Dayjs;
  end: Dayjs;
}

export const filterAvailableAppointments = ({
  appointments,
  start,
  end,
}: FilterAvailableAppointmentsParams) => {
  return appointments.filter((appointment) => {
    const appointmentDateTime = appointment.appointmentDate;

    return dayjs(appointmentDateTime).isBetween(start, end, null, "[]");
  });
};
